const faqArrow = document.querySelectorAll('.faq__card-question')
faqArrow.forEach(arrow => {
  arrow.addEventListener('click', () => {
    const upDownArrow = arrow.querySelector('i').classList.contains('fa-chevron-down') ? 'fa-chevron-up' : 'fa-chevron-down'
    arrow.querySelector('i').classList.toggle(upDownArrow)
  })
});